import 'dayjs/locale/es'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { useDashboardFilters } from '@contexts'

import { FilterGroup } from './styled'

dayjs.locale('es')

function formatMonthYearLabel(d: dayjs.Dayjs) {
  const raw = d.format('MMMM YYYY')
  return raw.charAt(0).toLocaleUpperCase('es') + raw.slice(1)
}

const MonthYearSelector = () => {
  const { t } = useTranslation()
  const { selectedMonth, setSelectedMonth } = useDashboardFilters()

  const currentYear = dayjs().year()

  return (
    <FilterGroup>
      <DatePicker
        picker="month"
        format={formatMonthYearLabel}
        allowClear={false}
        value={dayjs(selectedMonth)}
        onChange={d => {
          if (d) setSelectedMonth(d.startOf('month').toDate())
        }}
        disabledDate={current => {
          if (!current) return false
          if (current.year() !== currentYear) return true
          return current.isAfter(dayjs(), 'month')
        }}
        style={{ minWidth: 200 }}
        placeholder={t('admin_router.dashboard.month_selector')}
        aria-label={t('admin_router.dashboard.month_selector')}
      />
    </FilterGroup>
  )
}

export { MonthYearSelector }
